<template>
  <v-card variant="outlined" class="pa-2">
    <v-card-title class="text-subtitle-1 mb-1 pa-2">
      <v-icon class="me-1" size="small">mdi-account</v-icon>
      Personal Information
    </v-card-title>
    
    <v-form ref="personalForm" class="pa-1">
      <v-row class="ma-0">
        <v-col cols="12" md="6" class="pa-1">
          <v-text-field
            v-model="personalInfo.name"
            label="Full Name"
            variant="outlined"
            density="compact"
            hide-details="auto"
            :rules="[v => !!v || 'Name is required']"
            required
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="6" class="pa-1">
          <v-text-field
            v-model="personalInfo.name_bangla"
            label="Name (Bangla)"
            variant="outlined"
            density="compact"
            hide-details="auto"
            
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="6" class="pa-1">
          <v-text-field
            v-model="personalInfo.father_name"
            label="Father's / Husband's Name"
            variant="outlined"
            density="compact"
            hide-details="auto"
            
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="6" class="pa-1">
          <v-text-field
            v-model="personalInfo.mother_name"
            label="Mother's Name"
            variant="outlined"
            density="compact"
            hide-details="auto"
            
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="6" class="pa-1">
          <v-text-field
            v-model="personalInfo.mobile"
            label="Mobile Number"
            variant="outlined"
            density="compact"
            hide-details="auto"
            type="tel"
            :rules="[
              v => !v || /^[0-9+\-\s()]+$/.test(v) || 'Mobile number must contain only numbers and valid characters'
            ]"
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="6" class="pa-1">
          <v-text-field
            v-model="personalInfo.email"
            label="Email"
            variant="outlined"
            density="compact"
            hide-details="auto"
            type="email"
            :rules="[
              v => !v || /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'Email must be valid'
            ]"
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="6" class="pa-1">
          <v-text-field
            v-model="personalInfo.nid"
            label="National ID"
            variant="outlined"
            density="compact"
            hide-details="auto"
            
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="6" class="pa-1">
          <v-text-field
            v-model="personalInfo.passport_no"
            label="Passport Number"
            variant="outlined"
            density="compact"
            hide-details="auto"
            
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="6" class="pa-1">
          <v-date-input
            input-format="dd/mm/yyyy"
            v-model="personalInfo.date_of_birth"
            label="Date of Birth"
            prepend-icon=""
            prepend-inner-icon="mdi mdi-calendar-month"
            variant="outlined"
            density="compact"
            hide-details="auto"
          ></v-date-input>
        </v-col>
        <v-col cols="12" md="6" class="pa-1">
          <v-text-field
            v-model="personalInfo.nationality"
            label="Nationality"
            variant="outlined"
            density="compact"
            hide-details="auto"
            
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="6" class="pa-1">
          <v-text-field
            v-model="personalInfo.height"
            label="Height"
            variant="outlined"
            density="compact"
            hide-details="auto"
            
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="6" class="pa-1">
          <v-text-field
            v-model="personalInfo.weight"
            label="Weight"
            variant="outlined"
            density="compact"
            hide-details="auto"
            
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="6" class="pa-1">
          <v-select
            v-model="personalInfo.gender_id"
            label="Gender"
            variant="outlined"
            density="compact"
            hide-details="auto"
            :items="genders"
            item-title="text"
            item-value="value"
            :loading="loadingStates.genders"
            clearable
          ></v-select>
        </v-col>
        <v-col cols="12" md="6" class="pa-1">
          <v-select
            v-model="personalInfo.blood_group_id"
            label="Blood Group"
            variant="outlined"
            density="compact"
            hide-details="auto"
            :items="bloodGroups"
            item-title="text"
            item-value="value"
            :loading="loadingStates.bloodGroups"
            clearable
          ></v-select>
        </v-col>
        <v-col cols="12" md="6" class="pa-1">
          <v-select
            v-model="personalInfo.religion_id"
            label="Religion"
            variant="outlined"
            density="compact"
            hide-details="auto"
            :items="religions"
            item-title="text"
            item-value="value"
            :loading="loadingStates.religions"
            clearable
          ></v-select>
        </v-col>
        <v-col cols="12" md="6" class="pa-1">
          <v-select
            v-model="personalInfo.marital_status_id"
            label="Marital Status"
            variant="outlined"
            density="compact"
            hide-details="auto"
            :items="maritalStatuses"
            item-title="text"
            item-value="value"
            :loading="loadingStates.maritalStatuses"
            clearable
          ></v-select>
        </v-col>
        <v-col cols="12" md="6" class="pa-1">
          <v-text-field
            v-model="personalInfo.emergency_contact_person"
            label="Emergency Contact Person"
            variant="outlined"
            density="compact"
            hide-details="auto"
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="6" class="pa-1">
          <v-text-field
            v-model="personalInfo.emergency_contact_no"
            label="Emergency Contact Number"
            variant="outlined"
            density="compact"
            hide-details="auto"
          ></v-text-field>
        </v-col>
      </v-row>
    </v-form>
  </v-card>
</template>

<script setup>
import { ref, watch, onMounted } from 'vue'

// Props
const props = defineProps({
  personalInfo: {
    type: Object,
    required: true
  },
  genders: {
    type: Array,
    default: () => []
  },
  bloodGroups: {
    type: Array,
    default: () => []
  },
  religions: {
    type: Array,
    default: () => []
  },
  maritalStatuses: {
    type: Array,
    default: () => []
  },
  loadingStates: {
    type: Object,
    default: () => ({})
  }
})

// Emits
const emit = defineEmits(['update:personalInfo'])

// Local refs
const personalForm = ref(null)

// Watch for changes and emit updates
watch(() => props.personalInfo, (newValue) => {
  emit('update:personalInfo', newValue)
}, { deep: true })

// Load data on component mount

// Expose form validation method
defineExpose({
  validate: () => personalForm.value?.validate()
})
</script>

<style scoped>
/* Add any component-specific styles here */
</style>
